(() => {
  'use strict';
  const aliases = {
    kolichka:'количка',kolika:'количка','koli4ka':'количка',stolche:'столче',kosharka:'кошарка',
    blender:'блендер',kafemashina:'кафемашина',kafemelachka:'кафемелачка',aspirator:'аспиратор',
    pechka:'печка',hladilnik:'хладилник',xladilnik:'хладилник',televizor:'телевизор',telefon:'телефон',
    laptop:'лаптоп',prahosmukachka:'прахосмукачка',barbekyu:'барбекю',vintovert:'винтоверт',
    perforator:'перфоратор',kosachka:'косачка',trimer:'тример',cheren:'черен',byal:'бял',sin:'син',
    cherven:'червен',zelen:'зелен',rozov:'розов'
  };
  const rewrite = raw => { const value = String(raw || '').trim().replace(/\s+/g,' '); return (document.documentElement.lang || 'bg').toLowerCase().startsWith('bg') ? value.split(' ').map(w => aliases[w.toLowerCase()] || w).join(' ') : value; };
  const html = s => String(s ?? '').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const safeUrl = s => { try { const u = new URL(s, location.origin); return u.origin === location.origin ? u.pathname + u.search : '#'; } catch { return '#'; } };

  document.querySelectorAll('[data-bg-smart-search]').forEach(root => {
    if (root.dataset.ready === '1') return;
    root.dataset.ready = '1';
    const form = root.querySelector('[data-bg-smart-form]');
    const q = root.querySelector('[data-bg-smart-q]');
    const panel = root.querySelector('[data-bg-smart-panel]');
    const suggest = root.querySelector('[data-bg-smart-suggest]');
    const toggle = root.querySelector('[data-bg-smart-toggle]');
    if (!form || !q || !panel || !suggest || !toggle) return;

    toggle.addEventListener('click', () => {
      const open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    });

    root.querySelector('[data-bg-clear]')?.addEventListener('click', () => {
      root.querySelectorAll('[data-bg-filter]').forEach(el => el.value = '');
      q.value = '';
      suggest.hidden = true;
      q.focus();
    });

    let timer = 0;
    let controller = null;
    let requestSerial = 0;
    q.addEventListener('input', () => {
      clearTimeout(timer);
      const raw = q.value.trim();
      controller?.abort();
      const serial = ++requestSerial;
      if (raw.length < 2) { suggest.hidden = true; suggest.replaceChildren(); return; }
      timer = window.setTimeout(async () => {
        controller?.abort();
        controller = new AbortController();
        try {
          const term = window.BGShoppingSearchIntelligence?.normalize?.(rewrite(raw)) || rewrite(raw);
          const url = `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last`;
          const r = await fetch(url,{signal:controller.signal,headers:{Accept:'application/json'}});
          if (!r.ok) throw new Error('search');
          const j = await r.json();
          if (serial !== requestSerial || q.value.trim() !== raw) return;
          const results = j?.resources?.results || {};
          const products = (results.products || []).filter(p => p.available !== false).slice(0,5).map(p => `<a class="bgsmart__suggest-item" href="${safeUrl(p.url)}"><span><strong>${html(p.title)}</strong><small>${html(p.vendor || '')}</small></span><b>${typeof p.price === 'number' ? html(new Intl.NumberFormat(document.documentElement.lang || 'bg-BG',{style:'currency',currency:window.Shopify?.currency?.active || 'EUR'}).format(p.price / 100)) : html(p.price || '')}</b></a>`);
          const collections = (results.collections || []).slice(0,2).map(c => `<a class="bgsmart__suggest-item" href="${safeUrl(c.url)}"><span><strong>${(document.documentElement.lang || 'bg').toLowerCase().startsWith('bg') ? 'Категория' : 'Collection'}: ${html(c.title)}</strong></span></a>`);
          suggest.innerHTML = products.concat(collections).join('');
          suggest.hidden = !suggest.innerHTML;
        } catch (e) {
          if (e?.name !== 'AbortError' && serial === requestSerial) suggest.hidden = true;
        }
      },300);
    }, {passive:true});

    document.addEventListener('click', e => { if (!root.contains(e.target)) suggest.hidden = true; }, {passive:true});

    form.addEventListener('submit', e => {
      e.preventDefault();
      const url = new URL(form.action || '/search', location.origin);
      const term = window.BGShoppingSearchIntelligence?.normalize?.(rewrite(q.value)) || rewrite(q.value);
      if (!term) { q.focus(); return; }
      url.searchParams.set('q',term);
      url.searchParams.set('type','product');
      const min = root.querySelector('[data-bg-min-price]')?.value;
      const max = root.querySelector('[data-bg-max-price]')?.value;
      const brand = root.querySelector('[data-bg-brand]')?.value?.trim();
      if (min) url.searchParams.set('filter.v.price.gte',min);
      if (max) url.searchParams.set('filter.v.price.lte',max);
      if (brand) url.searchParams.set('filter.p.vendor',brand);
      location.assign(url.toString());
    });
  });
})();
